import React from "react";
import "../css/Pricing.css";

const Pricing = () => {
  return (
    <div className="pricing4">

      {/* ================= HERO ================= */}
      <section className="pr4-hero">
        <h1>Simple Pricing</h1>
        <p>Choose the plan that fits your glow-up journey.</p>
      </section>


      {/* ================= PRICING CARDS ================= */}
      <section className="pr4-plans">

        <div className="pr4-card">
          <h3>Starter</h3>
          <h2 className="price">$19<span>/mo</span></h2>
          <ul>
            <li>Gym Access</li>
            <li>Basic Classes</li>
            <li>Community Events</li>
          </ul>
          <button>Choose Starter</button>
        </div>

        <div className="pr4-card popular">
          <div className="badge">Most Popular</div>
          <h3>Plus</h3>
          <h2 className="price">$39<span>/mo</span></h2>
          <ul>
            <li>All Classes</li>
            <li>Tracking Insights</li>
            <li>Beginner Coaching</li>
          </ul>
          <button>Choose Plus</button>
        </div>

        <div className="pr4-card">
          <h3>Pro</h3>
          <h2 className="price">$69<span>/mo</span></h2>
          <ul>
            <li>1-on-1 Coaching</li>
            <li>Nutrition Guide</li>
            <li>Full App Access</li>
          </ul>
          <button>Choose Pro</button>
        </div>

      </section>



      {/* ================= ADD-ONS ================= */}
      <section className="pr4-addons">
        <h2>Boost Your Experience</h2>

        <div className="addons-grid">
          <div className="addon">
            <h3>Nutrition Pack</h3>
            <p>Weekly meal suggestions & ingredient lists.</p>
          </div>

          <div className="addon">
            <h3>Skill Workshops</h3>
            <p>Learn form, mobility & strength basics.</p>
          </div>

          <div className="addon">
            <h3>Recovery Kit</h3>
            <p>Foam roller + stretch plan + cooldown guide.</p>
          </div>

          <div className="addon">
            <h3>Premium Locker</h3>
            <p>Reserved space + towel service.</p>
          </div>
        </div>
      </section>



      {/* ================= COMPARISON TABLE ================= */}
      <section className="pr4-compare">
        <h2>Compare Plans</h2>

        <div className="cmp-wrapper">

          <div className="cmp-row header">
            <span>Feature</span>
            <span>Starter</span>
            <span>Plus</span>
            <span>Pro</span>
          </div>

          <div className="cmp-row"><span>Gym Access</span><span>✔</span><span>✔</span><span>✔</span></div>
          <div className="cmp-row"><span>All Classes</span><span>—</span><span>✔</span><span>✔</span></div>
          <div className="cmp-row"><span>Coaching</span><span>—</span><span>Basic</span><span>Pro</span></div>
          <div className="cmp-row"><span>Tracking Insights</span><span>—</span><span>✔</span><span>✔</span></div>
          <div className="cmp-row"><span>Nutrition Guide</span><span>—</span><span>—</span><span>✔</span></div>

        </div>
      </section>



      {/* ================= CTA ================= */}
      <section className="pr4-cta">
        <h1>Ready to Start?</h1>
        <p>Your glow-up begins with a single choice.</p>
        <button>Join Shank</button>
      </section>

    </div>
  );
};

export default Pricing;
